import { SharePosterParams } from "@/api/scode/poster";
import { sharePosterParams4H5Coupon, useShareConferencePoster } from "@/utils/actions";
import useNavigation from "@/utils/useNavigate";
import { Toast } from "antd-mobile";
import { inject, observer } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import exposure from "../../utils/expose/exposure";
import PosterSwipe from "../poster-swiper";

import { useShare } from "@/utils/share/share";
import { CouponModel } from "@akc/biz-api";
import { CouponListDS } from "@akc/decorate-ds";
import { CouponComp } from "@akc/mx-taro-h5-components";

interface Props {
  appStore?: any;
  propData?: any;
  pageData?: any;
  index?: any;
  trackInfo?: any;
  [key: string]: any;
}

const CouponCom: React.FC<Props> = (props: Props) => {
  const dataInfo = props.propData;

  const [coupons, setCoupons] = useState<any[]>(props.propData.dataInfo);

  const { shareCoupon } = useShare();
  const {
    navigate2Product,
    navigate2Activity,
    navigate2OfferOrderList,
    navigate2GoodsOfNpieceXfold,
  } = useNavigation();

  const { shareConferencePosterAction } = useShareConferencePoster();

  useEffect(() => {
    setCoupons(props.propData.dataInfo);
    const interval = setInterval(() => {
      let flag = false;
      for (let i = 0; i < props?.propData?.dataInfo?.length; i++) {
        const dom = document.getElementById(
          `${props.propData.componentCode}-${props.propData.dataInfo[i].awdId}`,
        );
        if (dom) {
          exposure.add({
            el: dom,
          });
        } else {
          flag = true;
        }
      }
      if (!flag) {
        clearInterval(interval);
      }
    }, 1000);
  }, [JSON.stringify(props.propData)]);

  // 转发海报相关
  const [showPoster, setShowPoster] = useState(false);
  const sharePosterData = useRef<SharePosterParams>();
  const onClosePoster = () => {
    sharePosterData.current = undefined;
    setShowPoster(false);
  };

  // h5 分享回调
  const share4H5Action = async voucherNo => {
    sharePosterData.current = sharePosterParams4H5Coupon({
      pageCode: props.pageData.pageCode,
      voucherNo: voucherNo,
    });
    setShowPoster(true);
  };

  // 进入小程序分享页面
  const shareCouponMiniAction = async voucherNo => {
    // 进入小程序分享页面
    shareCoupon(voucherNo);
  };

  const onActivityMakeupOrder = coupon => {
    const { isOldCoupon, awdId, voucherNo } = coupon;
    navigate2OfferOrderList({
      h5Query: isOldCoupon ? { couponId: awdId } : { voucherNo },
      miniQuery: isOldCoupon ? { id: awdId } : { voucherNo },
    });
  };

  const onActivityDetailAction = item => {
    navigate2Activity({
      activityNo: item.activityNo ?? item.activityId,
    });
  };

  const onProductMakeupOrder = coupon => {
    const { isOldCoupon, couponId, voucherNo, awdInstanceId } = coupon;
    navigate2GoodsOfNpieceXfold({
      h5Query: {
        couponId,
        voucherNo,
        awdInstanceId,
      },
      miniQuery: isOldCoupon
        ? {
            id: couponId,
            awdInstanceId,
          }
        : {
            voucherNo: voucherNo,
            awdInstanceId,
          },
    });
  };

  const onProductDetailAction = data => {
    navigate2Product({
      activitySpuId: data.activitySpuId,
      activityId: data.activityId,
      selectSkuId: data.selectSkuId,
    });
  };

  // app 分享回调
  const onShareAppAction = () => {
    shareConferencePosterAction(props.pageData);
  };

  if ((coupons?.length ?? 0) === 0) {
    return <></>;
  }

  return (
    <>
      <CouponComp
        customPageCode={props.pageData?.pageCode}
        customPageVersion={props.pageData?.version}
        paddingTop={props.pageData?.paddingTop || 0}
        paddingBottom={props.pageData?.paddingBottom || 0}
        trackData={props.trackInfo}
        couponInfo={dataInfo as CouponListDS}
        list={coupons as CouponModel[]}
        index={props.index}
        share4H5Action={share4H5Action}
        showToast={message => {
          Toast.show({
            content: message || "服务异常，请稍后重试！",
          });
        }}
        onActivityMakeupOrder={onActivityMakeupOrder}
        onActivityDetailAction={onActivityDetailAction}
        onProductMakeupOrder={coupon => {
          onProductMakeupOrder(coupon);
        }}
        onProductDetailAction={onProductDetailAction}
        shareCoupon={shareCouponMiniAction}
        shareCouponAction={onShareAppAction}
      />
      {/* 海报 */}
      {sharePosterData.current && (
        <PosterSwipe
          show={showPoster}
          posterData={sharePosterData.current}
          shareType="COUPON"
          btnConfig={["copy", "edit"]}
          close={onClosePoster}
        />
      )}
    </>
  );
};

export default inject("appStore")(observer(CouponCom));
